import { render, staticRenderFns } from "./Pulpit.vue?vue&type=template&id=2f2e620c&scoped=true&"
import script from "./Pulpit.vue?vue&type=script&lang=js&"
export * from "./Pulpit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2e620c",
  null
  
)

export default component.exports